export default __webpack_public_path__ + "static/media/32.2f19cbb7.png";